const API_URL = process.env.REACT_APP_API_URL

// ============================================
// STATS
// ============================================

export async function getCategorizationStats() {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/stats`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch stats')
  return response.json()
}

// ============================================
// CAMPAIGNS
// ============================================

export async function getCampaigns(params: {
  status?: string
  search?: string
  account_id?: string
  page?: number
  limit?: number
} = {}) {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value))
    }
  })

  const response = await fetch(`${API_URL}/admin/campaign-categorization/campaigns?${searchParams}`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch campaigns')
  return response.json()
}

export async function getCampaignPosts(campaignId: string, page = 1, limit = 20) {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/campaigns/${campaignId}/posts?page=${page}&limit=${limit}`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch posts')
  return response.json()
}

// ============================================
// AI ANALYSIS
// ============================================

export async function analyzeCampaign(campaignId: string) {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/campaigns/${campaignId}/analyze`, {
    method: 'POST',
    credentials: 'include'
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to analyze campaign')
  }
  return response.json()
}

export async function analyzeAllPending() {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/analyze-all`, {
    method: 'POST',
    credentials: 'include'
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to analyze campaigns')
  }
  return response.json()
}

export async function getAIStatus() {
  const response = await fetch(`${API_URL}/admin/ai/status`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to check AI status')
  return response.json()
}

// ============================================
// FINALIZATION
// ============================================

export async function finalizeCampaign(campaignId: string, data: {
  industry_id?: string
  location?: string
  library_name?: string
  assign_to_existing_library_id?: string
  create_new_industry?: boolean
  new_industry_name?: string
  new_industry_name_he?: string
}) {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/campaigns/${campaignId}/finalize`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data)
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to finalize campaign')
  }
  return response.json()
}

export async function resetCampaign(campaignId: string) {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/campaigns/${campaignId}/reset`, {
    method: 'POST',
    credentials: 'include'
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to reset campaign')
  }
  return response.json()
}

// ============================================
// SUGGESTED LIBRARIES
// ============================================

export async function getSuggestedLibraries() {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/suggested-libraries`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch suggested libraries')
  return response.json()
}

export async function createLibraryFromSuggestion(suggestedLibraryId: string) {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/suggested-libraries/${suggestedLibraryId}/create`, {
    method: 'POST',
    credentials: 'include'
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to create library')
  }
  return response.json()
}

// ============================================
// INDUSTRIES
// ============================================

export async function getIndustries(flat = false) {
  const response = await fetch(`${API_URL}/admin/industries?flat=${flat}`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch industries')
  return response.json()
}

export async function createIndustry(data: {
  name: string
  name_he: string
  parent?: string
  keywords?: string[]
}) {
  const response = await fetch(`${API_URL}/admin/industries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data)
  })
  if (!response.ok) {
    const err = await response.json()
    throw new Error(err.error || 'Failed to create industry')
  }
  return response.json()
}

// ============================================
// ACCOUNTS (for filtering)
// ============================================

export async function getAccounts() {
  const response = await fetch(`${API_URL}/admin/campaign-categorization/accounts`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch accounts')
  return response.json()
}

// ============================================
// PUBLIC LIBRARIES (for assignment)
// ============================================

export async function getPublicLibraries() {
  const response = await fetch(`${API_URL}/admin/libraries?is_public=true&limit=100`, {
    credentials: 'include'
  })
  if (!response.ok) throw new Error('Failed to fetch libraries')
  return response.json()
}
